import { useNavigate } from '@ksyos/router';
import { useState } from 'react';
import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { fetchJson } from '../../../store/fetch';
import { translateKey } from '../../../translate';
import { SendRequestMessageModal } from '../../pages/episodes/SendRequestMessageModal';
import { Button } from '../common';

export function RejectReferralButton(props: { reloadProcess: () => Promise<void>; request: IRequestGetOne }) {
    const navigate = useNavigate();
    const [isModalVisible, setIsModalVisible] = useState(false);

    if (
        !props.request.authorization ||
        !props.request.authorization.canUpdateRequestToRejected ||
        !props.request.requesterPractitioner
    ) {
        return null;
    }

    return (
        <>
            <Button
                automation="rejectReferral"
                color="secondary"
                large
                onClick={async () => {
                    setIsModalVisible(true);
                }}
                outlined
            >
                {translateKey('request.statusAction_rejected')}
            </Button>
            <SendRequestMessageModal
                isOpen={isModalVisible}
                onClose={() => setIsModalVisible(false)}
                onSent={async () => {
                    setIsModalVisible(false);
                    await fetchJson(`/api/requests/${props.request.id}/rejectReferral`, 'POST');
                    navigate('/home');
                }}
                requestId={props.request.id}
                toPractitioner={props.request.requesterPractitioner}
            />
        </>
    );
}
